export class ImageSettings {
	public sidebar_logo: string | null
	public login_logo: string | null
	public login_bg: string | null
	public favicon: string | null

	constructor(data: {
		sidebar_logo: string | null
		login_logo: string | null
		login_bg: string | null
		favicon: string | null
	}) {
		this.sidebar_logo = data.sidebar_logo
		this.login_logo = data.login_logo
		this.login_bg = data.login_bg
		this.favicon = data.favicon
	}

	static create(data: Partial<ImageSettings>): ImageSettings {
		const defaultData: ImageSettings = {
			sidebar_logo: null,
			login_logo: null,
			login_bg: null,
			favicon: null,
		}

		return new ImageSettings({
			...defaultData,
			...data,
		})
	}
}
